import { render, staticRenderFns } from "./merchant_more.vue?vue&type=template&id=0965d8e7&scoped=true"
import script from "./merchant_more.vue?vue&type=script&lang=js"
export * from "./merchant_more.vue?vue&type=script&lang=js"
import style0 from "./merchant_more.vue?vue&type=style&index=0&id=0965d8e7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0965d8e7",
  null
  
)

export default component.exports